define('sessionInfo',[
],

function () {
	/**
	 * A global object for storing information about the current OpenAnnotate session.
	 * @global
	 * @alias SessionInfo
	 */
	var SessionInfo = window.SessionInformation;

	return SessionInfo;
});
